import { render, staticRenderFns } from "./QuestionDeviceTerms.vue?vue&type=template&id=068ee43c&scoped=true&"
import script from "./QuestionDeviceTerms.vue?vue&type=script&lang=js&"
export * from "./QuestionDeviceTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ee43c",
  null
  
)

export default component.exports